import React, { useState, useRef, useEffect, useCallback } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import VideoWebcamRecorder from './Recorder';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import loading from './../../loading-gif-png-5.gif';

export default function Day4Practice(props) {
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const dispatch = useDispatch();
  const [displayCelebrateVideo, setDisplayCelebrateVideo] = useState(true);
  const [displayCelebrateAfterVideo, setDisplayCelebrateAfterVideo] =
    useState(false);
  const [displayCelebrateRecord, setDisplayCelebrateRecord] = useState(false);
  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [displayAudio, setDisplayAudio] = useState(false);
  const [displayGreeting, setDisplayGreeting] = useState(false);
  const [displayGreetingResponse, setDisplayGreetingResponse] = useState(false);
  const [displayQuestion7, setDisplayQuestion7] = useState(false);
  const [displayQuestion7Response, setDisplayQuestion7Response] =
    useState(false);
  const [displayQuestion, setDisplayQuestion] = useState(false);
  const [displayQuestionResponse, setDisplayQuestionResponse] = useState(false);
  const [displayAcknowledge, setDisplayAcknowledge] = useState(false);
  const [displayAcknowledge7, setDisplayAcknowledge7] = useState(false);
  const [displayGoodbye, setDisplayGoodbye] = useState(false);
  const [displayGoodbyeResponse, setDisplayGoodbyeResponse] = useState(false);
  const [playVideo, setPlayVideo] = useState('');
  const [animateCrab, setAnimateCrab] = useState(props.animal);
  const [playYouAreAwesome, setPlayYouAreAwesome] = useState(false);
  const [audioReady, setAudioReady] = useState(false);
  const [animalVoice, setAnimalVoice] = useState('');
  const [disPlayMessage, setDisplayMessage] = useState(false);
  const [disPlayConversation, setDisplayConversation] = useState(false);
  const [displayAnimal, setDisplayAnimal] = useState(false);

  const [animalSize, setAnimalSize] = useState(props.bigAnimal  ? (props.lizard ? 'lizard' : 'bigAnimal') : 'animateAnimal15')

  const [Exit, setExit] = useState(login.cloudFront + 'images/Images/close.png' + login.cookie);

  // Audio ref and expected src tracker
  const animalAudioRef = useRef(null);
  const expectedAnimalSrcRef = useRef('');

  // Helper to request playing an animal voice, restarting if same src
  const playAnimalVoice = useCallback(async (src, restartIfSame = true) => {
    const el = animalAudioRef.current;
    const currentSrc = el ? (el.currentSrc || el.src) : '';
    const same = !!currentSrc && currentSrc.includes(src);
    expectedAnimalSrcRef.current = src;
    if (el && same) {
      if (!restartIfSame) return;
      try {
        el.pause();
        el.currentTime = 0;
        await el.play();
      } catch (e) {
        const msg = String(e && e.message ? e.message : e);
        if (!msg.includes('interrupted by a new load request')) {
          // eslint-disable-next-line no-console
          console.log('animal audio replay failed', e);
        }
      }
    } else {
      setAnimalVoice(src);
    }
    setDisplayAnimal(true);
  }, []);

  const videoPlayer = {
    minWidth: '100%',
    minHeight: '100%',
    position: 'relative',
  };
  const videoPlayer1 = {
    width: '370px',
    height: '655px',
    zIndex: 20,
  };
  const checkModule = () => {
    setDisplayGreeting(true);
  };

  const closeCelebrate = (props) => {
    setAnimateCrab(props.animate4);
    playAnimalVoice(props.voice4);
    setPlayYouAreAwesome(true);
    setDisplayAnimal(true);
    props.module.sectionCompleted = props.module.sectionCompleted + 1
  };

  const displayVideo = () => {
    return (
      <>
        {displayCelebrateVideo && props.module.cameraOpen === false && (
          <CloudfrontVideoFormat
            source={props.celebrateVideo}
            back='/unit1'
            background={props.background}
            close={props.setDisplayDay4Practice}
            ended={() => {
              setDisplayCelebrateVideo(false);
              setDisplayCelebrateRecord(true);
              setAnimateCrab(props.animate2);
              playAnimalVoice(props.voice2);
              setDisplayMessage(true);
              setDisplayAnimal(true);
            }}
          />
        )}
        {displayCelebrateRecord && (
          <VideoWebcamRecorder
            background={props.background}
            question={props.question}
            outputText={props.text}
            name={props.name}
            setDisplayCelebrateAfterVideo={setDisplayCelebrateAfterVideo}
            setDisplayCelebrateRecord={setDisplayCelebrateRecord}
            voice={props.voice1}
            setPlayVideo={setPlayVideo}
            close={props.setDisplayDay4Practice}
          />
        )}
      </>
    );
  };

  // When the animal image finishes loading, trigger playback if ready
  useEffect(() => {
    if (!displayAudio) return;
    const el = animalAudioRef.current;
    if (!el || !el.src) return;
    if (!el.paused) return;
    el.currentTime = 0;
    el.play().catch(() => {});
  }, [displayAudio]);
  return (
    <>
      {/* Always-mounted audio for iOS reliability */}
      <audio
        ref={animalAudioRef}
        src={animalVoice}
        preload='auto'
        playsInline
        onLoadedData={() => {
          const el = animalAudioRef.current;
          if (!el) return;
          // Only play when the animal image has loaded (displayAudio true)
          if (!displayAudio) return;
          const expected = expectedAnimalSrcRef.current;
          const currentSrc = el.currentSrc || el.src;
          if (!expected || (currentSrc && !currentSrc.includes(expected))) return;
          el.currentTime = 0;
          el.play().catch((e) => {
            const msg = String(e && e.message ? e.message : e);
            if (!msg.includes('interrupted by a new load request')) {
              // eslint-disable-next-line no-console
              console.log('animal audio play failed', e);
            }
          });
        }}
        onPlay={() => {
          setAudioReady(true);
        }}
        onEnded={() => {
          if (disPlayConversation) {
            checkModule();
            setDisplayConversation(false);
          }
          if (disPlayMessage) {
            setDisplaySurprise(true);
            setDisplayMessage(false);
          }
          if (playYouAreAwesome) {
            if (props.module.reviewIcon === false) {
              dispatch({
                type: `${props.moduleNum}_SET_stepCompleted`,
                payload: 'practice',
              });
            }
            props.setDisplayDay4Practice(false);
          }
          setAudioReady(false);
          setDisplayAudio(false);
        }}
      />

      {!displayCelebrateAfterVideo && displayVideo()}
      {displayCelebrateAfterVideo && (
        <div
          id='recordpage'
          style={{ backgroundImage: `url(${props.background})` }}
        >
          <img
            alt=''
            className='back-btn-ftb'
            src={Exit}
            onClick={() => {
              props.setDisplayDay4Practice(false);
            }}
          ></img>

          {displaySurprise && (
            <div id='influencerVideo'>
              <video
                style={videoPlayer}
                autoPlay
                onError={() => (
                  setDisplaySurprise(false),
                  setDisplayConversation(true),
                  setAnimateCrab(props.animate3),
                  playAnimalVoice(props.voice3),
                  setDisplayAnimal(true)
                )}
                onEnded={() => (
                  setDisplaySurprise(false),
                  setDisplayConversation(true),
                  setAnimateCrab(props.animate3),
                  playAnimalVoice(props.voice3),
                  setDisplayAnimal(true)
                )}
                playsInline
              >
                <source src={props.influencerVideo} type='video/mp4'></source>
              </video>
            </div>
          )}

          {/* MODULE6 */}
          {displayGreeting && props.moduleNum === 'MODULE6' && (
            <div id='borderVideo'>
              <video
                style={videoPlayer1}
                autoPlay
                onEnded={() => (
                  setDisplayGreetingResponse(true), setDisplayGreeting(false)
                )}
                onError={() => (
                  setDisplayGreetingResponse(true), setDisplayGreeting(false)
                )}
                playsInline
              >
                <source src={props.greeting} type='video/mp4'></source>
              </video>
            </div>
          )}
          {displayGreetingResponse && props.moduleNum === 'MODULE6' && (
            <div id='border'>
              <video
                style={{ width: '391px', height: '580px', left: '50%' }}
                autoPlay
                onEnded={() => {
                  closeCelebrate(props);
                  setDisplayGreetingResponse(false);
                }}
                onError={() => {
                  closeCelebrate(props);
                  setDisplayGreetingResponse(false);
                }}
                playsInline
              >
                <source src={playVideo} type='video/mp4'></source>
              </video>
            </div>
          )}

          {/* MODULE7 */}
          {displayGreeting && props.moduleNum === 'MODULE7' && (
            <div id='borderVideo'>
              <video
                style={videoPlayer1}
                autoPlay
                onEnded={() => (
                  setDisplayGreetingResponse(true), setDisplayGreeting(false)
                )}
                onError={() => (
                  setDisplayGreetingResponse(true), setDisplayGreeting(false)
                )}
                playsInline
              >
                <source src={props.greeting} type='video/mp4'></source>
              </video>
            </div>
          )}
          {displayGreetingResponse && props.moduleNum === 'MODULE7' && (
            <div id='border'>
              <video
                style={{ width: '391px', height: '580px', left: '50%' }}
                autoPlay
                onEnded={() => (
                  setDisplayGreetingResponse(false), setDisplayQuestion(true)
                )}
                onError={() => (
                  setDisplayGreetingResponse(false), setDisplayQuestion(true)
                )}
                playsInline
              >
                <source src={props.greetingResponse} type='video/mp4'></source>
              </video>
            </div>
          )}
          {displayQuestion && props.moduleNum === 'MODULE7' && (
            <div id='borderVideo'>
              <video
                style={videoPlayer1}
                autoPlay
                onEnded={() => (
                  setDisplayQuestionResponse(true), setDisplayQuestion(false)
                )}
                onError={() => (
                  setDisplayQuestionResponse(true), setDisplayQuestion(false)
                )}
                playsInline
              >
                <source src={props.question} type='video/mp4'></source>
              </video>
            </div>
          )}
          {displayQuestionResponse && props.moduleNum === 'MODULE7' && (
            <div id='border'>
              <video
                style={{ width: '391px', height: '580px', left: '50%' }}
                autoPlay
                onEnded={() => (
                  setDisplayQuestionResponse(false), setDisplayAcknowledge(true)
                )}
                onError={() => (
                  setDisplayQuestionResponse(false), setDisplayAcknowledge(true)
                )}
                playsInline
              >
                <source src={playVideo} type='video/mp4'></source>
              </video>
            </div>
          )}
          {displayAcknowledge && props.moduleNum === 'MODULE7' && (
            <div id='borderVideo'>
              <video
                style={videoPlayer1}
                autoPlay
                onEnded={() => (
                  closeCelebrate(props), setDisplayAcknowledge(false)
                )}
                onError={() => (
                  closeCelebrate(props), setDisplayAcknowledge(false)
                )}
                playsInline
              >
                <source src={props.acknowledge} type='video/mp4'></source>
              </video>
            </div>
          )}

          {/* MODULE8 && MODULE9 && MODULE10 */}
          {displayGreeting &&
            (props.moduleNum === 'MODULE8' ||
              props.moduleNum === 'MODULE9' ||
              props.moduleNum === 'MODULE10' ||
              props.moduleNum === 'MODULE13' ||
              props.moduleNum === 'MODULE14' ||
              props.moduleNum === 'MODULE15') && (
              <div id='borderVideo'>
                <video
                  style={videoPlayer1}
                  autoPlay
                  onEnded={() => (
                    setDisplayGreetingResponse(true), setDisplayGreeting(false)
                  )}
                  onError={() => (
                    setDisplayGreetingResponse(true), setDisplayGreeting(false)
                  )}
                  playsInline
                >
                  <source src={props.greeting} type='video/mp4'></source>
                </video>
              </div>
            )}
          {displayGreetingResponse &&
            (props.moduleNum === 'MODULE8' ||
              props.moduleNum === 'MODULE9' ||
              props.moduleNum === 'MODULE10' ||
              props.moduleNum === 'MODULE13' ||
              props.moduleNum === 'MODULE14' ||
              props.moduleNum === 'MODULE15') && (
              <div id='border'>
                <video
                  style={{ width: '391px', height: '580px', left: '50%' }}
                  autoPlay
                  onEnded={() => (
                    setDisplayGreetingResponse(false), setDisplayQuestion7(true)
                  )}
                  onError={() => (
                    setDisplayGreetingResponse(false), setDisplayQuestion7(true)
                  )}
                  playsInline
                >
                  <source
                    src={props.greetingResponse}
                    type='video/mp4'
                  ></source>
                </video>
              </div>
            )}

          {displayQuestion7 && (
            <div id='borderVideo'>
              <video
                style={videoPlayer1}
                autoPlay
                onEnded={() => (
                  setDisplayQuestion7Response(true), setDisplayQuestion7(false)
                )}
                onError={() => (
                  setDisplayQuestion7Response(true), setDisplayQuestion7(false)
                )}
                playsInline
              >
                <source src={props.question7} type='video/mp4'></source>
              </video>
            </div>
          )}
          {displayQuestion7Response && (
            <div id='border'>
              <video
                style={{ width: '391px', height: '580px', left: '50%' }}
                autoPlay
                onEnded={() => (
                  setDisplayQuestion7Response(false),
                  setDisplayAcknowledge7(true)
                )}
                onError={() => (
                  setDisplayQuestion7Response(false),
                  setDisplayAcknowledge7(true)
                )}
                playsInline
              >
                <source src={props.response7} type='video/mp4'></source>
              </video>
            </div>
          )}
          {displayAcknowledge7 && (
            <div id='borderVideo'>
              <video
                style={videoPlayer1}
                autoPlay
                onEnded={() => (
                  setDisplayQuestion(true), setDisplayAcknowledge7(false)
                )}
                onError={() => (
                  setDisplayQuestion(true), setDisplayAcknowledge7(false)
                )}
                playsInline
              >
                <source src={props.acknowledge7} type='video/mp4'></source>
              </video>
            </div>
          )}

          {/* MODULE8 */}
          {displayQuestion &&
            (props.moduleNum === 'MODULE8' ||
              props.moduleNum === 'MODULE13') && (
              <div id='border'>
                <video
                  style={{ width: '391px', height: '580px', left: '50%' }}
                  autoPlay
                  onEnded={() => (
                    setDisplayQuestionResponse(true), setDisplayQuestion(false)
                  )}
                  onError={() => (
                    setDisplayQuestionResponse(true), setDisplayQuestion(false)
                  )}
                  playsInline
                >
                  <source src={playVideo} type='video/mp4'></source>
                </video>
              </div>
            )}
          {displayQuestionResponse &&
            (props.moduleNum === 'MODULE8' ||
              props.moduleNum === 'MODULE13') && (
              <div id='borderVideo'>
                <video
                  style={videoPlayer1}
                  autoPlay
                  onEnded={() => (
                    setDisplayQuestionResponse(false), closeCelebrate(props)
                  )}
                  onError={() => (
                    setDisplayQuestionResponse(false), closeCelebrate(props)
                  )}
                  playsInline
                >
                  <source src={props.response} type='video/mp4'></source>
                </video>
              </div>
            )}

          {/* MODULE9 && MODULE10 */}
          {displayQuestion &&
            (props.moduleNum === 'MODULE9' ||
              props.moduleNum === 'MODULE10' ||
              props.moduleNum === 'MODULE14' ||
              props.moduleNum === 'MODULE15') && (
              <div id='border'>
                <video
                  style={{ width: '391px', height: '580px', left: '50%' }}
                  autoPlay
                  onEnded={() => (
                    setDisplayQuestionResponse(true), setDisplayQuestion(false)
                  )}
                  onError={() => (
                    setDisplayQuestionResponse(true), setDisplayQuestion(false)
                  )}
                  playsInline
                >
                  <source src={props.ask} type='video/mp4'></source>
                </video>
              </div>
            )}
          {displayQuestionResponse &&
            (props.moduleNum === 'MODULE9' ||
              props.moduleNum === 'MODULE10' ||
              props.moduleNum === 'MODULE14' ||
              props.moduleNum === 'MODULE15') && (
              <div id='borderVideo'>
                <video
                  style={videoPlayer1}
                  autoPlay
                  onEnded={() => (
                    setDisplayQuestionResponse(false),
                    setDisplayAcknowledge(true)
                  )}
                  onError={() => (
                    setDisplayQuestionResponse(false),
                    setDisplayAcknowledge(true)
                  )}
                  playsInline
                >
                  <source src={props.response} type='video/mp4'></source>
                </video>
              </div>
            )}

          {/* MODULE9 */}
          {displayAcknowledge &&
            (props.moduleNum === 'MODULE9' ||
              props.moduleNum === 'MODULE14') && (
              <div id='border'>
                <video
                  style={{ width: '391px', height: '580px', left: '50%' }}
                  autoPlay
                  onEnded={() => (
                    setDisplayAcknowledge(false), closeCelebrate(props)
                  )}
                  onError={() => (
                    setDisplayAcknowledge(false), closeCelebrate(props)
                  )}
                  playsInline
                >
                  <source src={playVideo} type='video/mp4'></source>
                </video>
              </div>
            )}

          {/* MODULE10 */}
          {displayAcknowledge &&
            (props.moduleNum === 'MODULE10' ||
              props.moduleNum === 'MODULE15') && (
              <div id='border'>
                <video
                  style={{ width: '391px', height: '580px', left: '50%' }}
                  autoPlay
                  onEnded={() => (
                    setDisplayGoodbye(true), setDisplayAcknowledge(false)
                  )}
                  onError={() => (
                    setDisplayGoodbye(true), setDisplayAcknowledge(false)
                  )}
                  playsInline
                >
                  <source src={props.acknowledge} type='video/mp4'></source>
                </video>
              </div>
            )}

          {displayGoodbye && (
            <div id='borderVideo'>
              <video
                style={videoPlayer1}
                autoPlay
                onEnded={() => (
                  setDisplayGoodbye(false), setDisplayGoodbyeResponse(true)
                )}
                onError={() => (
                  setDisplayGoodbye(false), setDisplayGoodbyeResponse(true)
                )}
                playsInline
              >
                <source src={props.close} type='video/mp4'></source>
              </video>
            </div>
          )}

          {displayGoodbyeResponse && (
            <div id='border'>
              <video
                style={{ width: '391px', height: '580px', left: '50%' }}
                autoPlay
                onEnded={() => (
                  setDisplayGoodbyeResponse(false), closeCelebrate(props)
                )}
                onError={() => (
                  setDisplayGoodbyeResponse(false), closeCelebrate(props)
                )}
                playsInline
              >
                <source src={playVideo} type='video/mp4'></source>
              </video>
            </div>
          )}
          {displayAnimal && (
            <img
              alt=''
              className={animalSize}
              style={audioReady ? {} : { display: 'none' }}
              onLoad={() => setDisplayAudio(true)}
              src={animateCrab}
            />
          )}
          {displayAnimal && !audioReady && (
            <img alt='' id='loading' src={loading} />
          )}
        </div>
      )}
    </>
  );
}
